<template>
	<div class="c-inquiry__body">
		<div class="inquiry-form__title-block">
			<p class="inquiry-form__form-title">{{msg.personal_info}}</p>
		</div>

		<div class="row">
			<div class="col-12 col-lg-6">
				<label class="inquiry-form__label">
					<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name+(required_fields.first_name?' *':'')">
				</label>
			</div>
			<div class="col-12 col-lg-6">
				<label class="inquiry-form__label">
					<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name+(required_fields.last_name?' *':'')">
				</label>
			</div>
		</div>

		<div class="inquiry-form__title-block">
			<p class="inquiry-form__form-title">{{msg.child_info}}</p>
		</div>

		<div v-for="(child, index) in children" :key="index" class="row row--spaced">
			<div class="col-12 col-lg-6">
				<label class="inquiry-form__label">
					<input type="text" name="child_name" v-model="child.name" value="" class="inquiry-form__input-text" :placeholder="msg.child_name">
				</label>
			</div>
			<div class="col-12 col-lg-6">
				<p class="inquiry-form__section-lebel ">{{msg.child_age}} </p>
				<multiselect :options="childAges" v-model="child.age" :searchable="false" :close-on-select="true" :show-labels="false"></multiselect>
			</div>

			<div class="col-12 col-lg-3">
				<p class="inquiry-form__section-lebel ">{{msg.stay_period}}</p>
				<multiselect :options="stayPeriods" v-model="child.stay" :searchable="false" :close-on-select="true" :show-labels="false"></multiselect>
			</div>
			<div class="col-12 col-lg-6">
				<p class="inquiry-form__section-lebel ">{{msg.child_activity}} </p>
				<multiselect :options="activities" v-model="child.activity" :searchable="false" :close-on-select="true" :show-labels="false"></multiselect>
			</div>
		</div>

		<a href="#" class="inquiry-form__add-btn" @click.prevent="addChild()">{{msg.add_child}}</a>
		<div class="row">
			<div class="col-12 col-lg-6">
				<label class="inquiry-form__label">
					<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email+(required_fields.email?' *':'')">
				</label>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<label class="inquiry-form__label">
					<textarea name="message" rows="8" cols="80" :placeholder="msg.message+(required_fields.message?' *':'')" class="inquiry-form__input-textarea"></textarea>
				</label>
			</div>
		</div>

		<div class="inquiry-form__bottom">
			<div class="inquiry-form__opt">
				<label class="inquiry-form__label">
					<input type="hidden" name="gdpr_accept" value="false" class="inquiry-form__input-check">
					<input type="checkbox" name="gdpr_accept" value="true" class="inquiry-form__input-check">
					<span style="margin-left:5px;" v-html="msg.form_gdpr+(required_fields.gdpr_accept?' *':'')"></span>
				</label>
				<label class="inquiry-form__label">
					<input type="hidden" name="newsletter_accept" value="false" class="inquiry-form__input-check">
					<input type="checkbox" name="newsletter_accept" value="true" class="inquiry-form__input-check">
					<span style="margin-left:5px;" v-html="msg.form_newsletter+(required_fields.newsletter_accept?' *':'')"></span>
				</label>

			</div>
		</div>

		<input type="hidden" name="children" :value="childrenJSON">

	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from "vuex";

export default {
	props: {
		required_fields: Object
	},
	
	components: {
		Multiselect
	},
	data() {
		return {
			children: [],
			defaultChild: {
				name: '',
				age: 0,
				stay: 0,
				activity: ''
			},
			childAges: Array.apply(null, {length: 17}).map(Number.call, Number),  
			stayPeriods: Array.apply(null, {length: 17}).map(Number.call, Number),
			activities: []
		} 
	},
	created() {
		this.defaultChild.activity = this.msg.sport_form_football
		this.activities = [this.msg.sport_form_football,this.msg.sport_form_tennis,this.msg.sport_form_basketball,this.msg.sport_form_swimming,this.msg.sport_form_camp]
		this.addChild();
	},
	methods: {
		addChild() {
			this.children.push(_.cloneDeep(this.defaultChild));
		}
	},
	computed: {
		childrenJSON() {
			return JSON.stringify(this.children);
		},
		...mapState({
			msg: state => state.msg,
		})
	}
}
</script>

<style>

</style>
